// Define supported locales
export type Locale = 'en' | 'nl';

// Type-safe locale validation
export function validateLocale(locale: string | undefined): locale is Locale {
  return ['en', 'nl'].includes(locale as Locale);
}
